var util = angular.module('gymsystem.util');
// Enhanced multi-select directive (field.version === 2) wrapping the Select2 jQuery plugin.
// Differences vs. the plain <select multiple> used for multiselect fields without a version:
//   - Styled tag-based picker with a live search input (no native browser select box)
//   - Custom search: filters options as you type, supports ordered multi-word matching
//   - Smart result sorting: starts-with match first, then by word depth, then alphabetically
//   - Supports field.getName(d) for custom label logic and field.orderPredicate for custom sort order
//   - Selected tags are jQuery UI sortable — the user can drag to reorder them
//   - ngModel holds full data objects (cached by id), not just IDs
util.directive('gsSelect2', ['$filter', 'util', function ($filter, util) {
        'use strict';
        return {
            scope: {
                'field': '='
            },
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, $element, $attrs, ngModel) {
                var field = scope.field;
                var $el = $($element[0]);
                function matched(text, f) {
                    if (!f)
                        return true;
                    if (!text)
                        return false;
                    text = text.toLowerCase();
                    if (f.indexOf(' ') != -1) {
                        var i = 0;
                        for (var _i = 0, _a = f.split(' '); _i < _a.length; _i++) {
                            var w = _a[_i];
                            i = text.indexOf(w, i);
                            if (i == -1) {
                                return false;
                            }
                            i += w.length;
                        }
                        return true;
                    }
                    return text.indexOf(f) != -1;
                }
                var cache = {};
                var applying = false;
                var query = function (q) {
                    var text = q.term.toLowerCase();
                    var textFilter = text ? text.split(' ') : null;
                    var results = [];
                    field.options().forEach(function (d) {
                        var name = field.getName ? field.getName(d) : d.name;
                        if (!matched(name, text))
                            return;
                        cache[d.id] = d;
                        results.push({
                            id: d.id,
                            name: name,
                            depth: name.split(' ').length,
                            order: field.orderPredicate ? (_.isFunction(field.orderPredicate) ? field.orderPredicate(d) : field.orderPredicate) : name.toLowerCase()
                        });
                    });
                    // Sorting
                    // 1. Field begins with search string
                    // 2. Smallest depth
                    // 3. Alphabetically
                    results.sort(function (a, b) {
                        if (a.order == b.order) {
                            return 0;
                        }
                        var as = a.order.startsWith(text);
                        var bs = b.order.startsWith(text);
                        if (as && !bs) {
                            return -1;
                        }
                        else if (bs && !as) {
                            return 1;
                        }
                        if (a.depth != b.depth) {
                            return a.depth - b.depth;
                        }
                        return a.order < b.order ? -1 : 1;
                    });
                    q.callback({ results: results });
                };
                var format = function (d) { return util.escapeHtml(d.name); };
                $el.select2({
                    formatResult: format,
                    formatSelection: format,
                    placeholder: $filter('translate')($attrs.selectPlaceholder),
                    allowClear: true,
                    query: query,
                    multiple: true,
                    escapeMarkup: function (m) { return m; }
                });
                $el.on("change", function (e) {
                    ngModel.$setViewValue(e.val.map(function (id) { return cache[id]; }));
                    applying = true;
                    scope.$apply();
                    applying = false;
                });
                $el.select2("container").find("ul.select2-choices").sortable({
                    containment: 'parent',
                    start: function () {
                        return $el.select2("onSortStart");
                    },
                    update: function () {
                        return $el.select2("onSortEnd");
                    }
                });
                scope.$on('$destroy', function () { return $el.select2('destroy'); });
                ngModel.$render = function () {
                    if (applying)
                        return;
                    var data = ngModel.$viewValue;
                    data = (data || []).map(function (d) {
                        cache[d.id] = d;
                        return {
                            id: d.id,
                            name: field.getName(d),
                            locked: d.locked
                        };
                    });
                    $el.select2("data", data);
                };
            } // link
        };
    }]);
